import { render, staticRenderFns } from "./FacActTab.vue?vue&type=template&id=056f191d&scoped=true&"
import script from "./FacActTab.vue?vue&type=script&lang=js&"
export * from "./FacActTab.vue?vue&type=script&lang=js&"
import style0 from "./FacActTab.vue?vue&type=style&index=0&id=056f191d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056f191d",
  null
  
)

export default component.exports